define('Tracker',['jquery','Slider','JSTemplate', 'History'], function($, Slider, template, History) {
	var defaults = {
		type: 'pregnancy'
	},

	init = function(options) {
		o = $.extend(defaults, options);

	    $('.slider').aminoSlider({
            offset: (o.type === 'pregnancy') ? 4 : 1,
            tooltip: (o.type === 'pregnancy') ? ' weeks' : ' months',
            type: o.type,
            url: (o.type === 'pregnancy') ? '/ajax/pregnancy-tracker' : '/ajax/baby-tracker',
            leftImage: (o.type === 'pregnancy') ? 'assets/images/tracker/pregnancy-tracker-stage0.png' : 'assets/images/tracker/pregnancy-tracker-stageend.png',
            rightImage: (o.type === 'pregnancy') ? 'assets/images/tracker/pregnancy-tracker-stageend.png' : 'assets/images/tracker/baby-tracker-stageend.png',

            callback: function(data) {
								var postData = {};
								if(o.type == 'pregnancy') {
									postData = {weekNo: data.week}
								} else {
									postData = {monthNo: data.week}
								}
                $.post(data.url,postData,function(response) {

                    if(response.status) {
                        var html = template('tplTracker',
                        {
                            data: (o.type == 'pregnancy') ? response.response.week : response.response.month,
                            langs: window._gtap.settings.lang,
														type: o.type
                        });

                        $('.tracker-data').html(html);

                        History.pushState({
                            url: (o.type == 'pregnancy') ? response.response.week.url : response.response.month.url,
                            title: (o.type === 'pregnancy') ? 'Pregnancy Tracker' : 'Baby Tracker',
                            callback: function() {
                                var locationHref = window.location.href.lastIndexOf('-'),
                                    currentWeek  = parseInt($('.week-header').attr('data-week'));
                                    week = parseInt(window.location.href.substring(locationHref+1));

                                if(week > currentWeek) {
                                    $('.tracker-parent .btn-right').click();
                                } else {
                                    $('.tracker-parent .btn-left').click();
                                }

                            }
                        });

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('click', {
                                target: (o.type === 'pregnancy') ? 'pregnancy tracker' : 'baby tracker'
                            });
                        });
                    }
                });
            }
        });
	};

	return {
		init: init
	}
});

